<template lang="pug">
  el-dialog.kol-quotation-reference-dialog(
    v-loading="loading"
    :visible="visible"
    @close="$emit('cancel')"
    width="1200px"
    :show-close="false"
  )
    template(slot="title")
      .dialog__header
        span {{ $t('KOL方案报价参考') }}
        div
          el-input(
            v-model="keyword"
            :placeholder="$t('请输入搜索内容')"
            @keyup.enter.native="handleSearch"
          )
            i(
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
            )
          el-tooltip(
            placement="top"
            :content="$t('导出明细')"
          )
            a(
              :href="kol_download_path"
              target="_blank"
            )
              i.iconfont.icon-daochu1
    el-table(
      :data="kolList.table_data"
      :row-class-name="tableRowClassName"
    )
      el-table-column(
        prop="num"
        label="No."
        width="80"
      )
      el-table-column(
        label="KOL"
      )
        template(slot-scope="scope")
          span(style="margin-right: 5px") {{ scope.row.kol_name }}
          i(v-if="scope.row.in_blacklist === 1").iconfont.icon-heimingdan
      el-table-column(
        prop="kol_type"
        :label="$t('所属类别')"
      )
      el-table-column(
        prop="channel"
        :label="$t('所属平台')"
        width="110"
      )
      el-table-column(
        prop="price"
        :label="$t('供应商报价')"
        align="right"
        width="120"
      )
        template(slot-scope="scope")
          span {{ scope.row.price | formatMoney }}
      el-table-column(
        prop="history_price"
        align="right"
        :label="$t('历史报价')"
      )
        template(
          slot="header" slot-scope="scope"
        )
          span {{ $t('历史报价') }}
          el-tooltip(
            placement="top"
            :content="$t('该列为与该KOL最近一次营销合作中给到的报价')"
          )
            i.iconfont.icon-wenhao(
              style="margi-left: 10px"
            )
        template(slot-scope="scope")
          span(v-if="scope.row.history_price !== 0") {{ scope.row.history_price | formatMoney }}
          span(v-else) —
      el-table-column(
        prop="price_newrank"
        align="right"
        :label="$t('新榜报价')"
      )
        template(
          slot="header" slot-scope="scope"
        )
          span {{ $t('新榜报价') }}
          el-tooltip(
            placement="top"
            :content="$t('该列为新榜针对不同KOL所提供的标准报价，仅供议价参考使用。')"
          )
            i.iconfont.icon-wenhao(
              style="margi-left: 10px"
            )
        template(slot-scope="scope")
          span(v-if="scope.row.price_newrank !== 0") {{ scope.row.price_newrank | formatMoney }}
          span(v-else) —
      el-table-column(
        prop="price_ims"
        align="right"
        :label="$t('IMS报价')"
      )
        template(
          slot="header" slot-scope="scope"
        )
          span {{ $t('IMS报价') }}
          el-tooltip(
            placement="top"
            :content="$t('该列为IMS针对不同KOL所提供的标准报价，仅供议价参考使用。')"
          )
            i.iconfont.icon-wenhao(
              style="margi-left: 10px"
            )
        template(slot-scope="scope")
          span(v-if="scope.row.price_ims !== 0") {{ scope.row.price_ims | formatMoney }}
          span(v-else) —
      el-table-column(
        prop="price_weiboyi"
        align="right"
        width="160"
        :label="$t('微播易报价')"
      )
        template(
          slot="header" slot-scope="scope"
        )
          span {{ $t('微播易报价') }}
          el-tooltip(
            placement="top"
            :content="$t('该列为微播易针对不同KOL所提供的标准报价，仅供议价参考使用。')"
          )
            i.iconfont.icon-wenhao(
              style="margi-left: 10px"
            )
        template(slot-scope="scope")
          span(v-if="scope.row.price_weiboyi !== 0") {{ scope.row.price_weiboyi | formatMoney }}
          span(v-else) —
    el-pagination(
      style="text-align: right;padding: 16px 0 0"
      layout="prev, pager, next, jumper"
      :page-size="10"
      :total="kolList.total_row"
      :current-page.sync="currentPage"
      @current-change='getKolQuotationList(0)',
    )
    template(slot="footer")
      el-button(
        type="primary"
        @click="$emit('cancel')"
      ) {{ $t('返回') }}
</template>

<script>
import axios from 'axios'
import { formatMoney } from '@/umcc/util'
export default {
  filters: {
    formatMoney
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    subFinalScopeVendorId: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      currentPage: 1,
      keyword: '',
      loading: false,
      kolList: {
        table_data: []
      },
      kol_download_path: null
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    getKolQuotationList (exportFile) {
      this.loading = true
      axios.get('/kol/getKolQuotationList', {
        params: {
          sub_final_scope_vendor_id: this.subFinalScopeVendorId,
          keyword: exportFile === 1 ? '' : this.keyword,
          page_number: this.currentPage,
          page_size: 10,
          export_file: exportFile
        }
      })
        .then(res => {
          if (exportFile === 0) {
            this.kolList = res
          } else {
            this.kol_download_path = res.file_download_path
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    async fetchData () {
      try {
        await Promise.all([this.getKolQuotationList(0), this.getKolQuotationList(1)])
      } catch (err) {
        throw new Error(err)
      }
    },
    tableRowClassName ({row}) {
      return row.in_blacklist === 1 ? 'disabled-row' : ''
    },
    handleSearch () {
      this.currentPage = 1
      this.getKolQuotationList(0)
    }
  }
}
</script>

<style lang="stylus">
.kol-quotation-reference-dialog
  .el-dialog__header
    .dialog__header
      display flex
      justify-content space-between
      align-items center
      span
        color $title-color
        font-size 16px
        font-weight 500
      > div
        display flex
        align-items center
        > .el-input
            i
              color $disabled
        > a
          margin-left 16px
          color $main
          font-size 18px
          font-weight 600
  .el-dialog__body
    .icon-wenhao
      font-size 12px
      margin-left 5px
  .el-dialog__footer
    text-align center
    padding 24px 32px 32px
    .el-button
      width 140px
      font-weight normal
      height 32px
  .el-table
    overflow auto
    flex none
    th
      &:nth-child(1)
        padding-left: 14px
      &:last-child
        padding-right: 14px
    tbody
      tr
        td
          padding-top 12px
          padding-bottom 12px
          &:nth-child(1)
            padding-left: 14px
          &:last-child
            padding-right: 14px
    .disabled-row
      color $disabled
    .caret-wrapper
      height 28px
      width 18px
      .ascending
        top 2px
        cursor pointer
      .descending
        bottom 3px
        cursor pointer
</style>
